export default (_that) => [
  {
    field: "seq",
    width: 60,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    title: _that.$l("table_label_Business_unit") || "业务部门",
    field: "depName",
    minWidth: 180,
    align: "left",
    headerAlign: "center",
    showHeaderOverflow: "title",
    showOverflow: true,
    fixed: "left",
  },
  {
    title: _that.$l("table_label_Business_personnel") || "业务人员",
    field: "sales",
    minWidth: 180,
    align: "left",
    headerAlign: "center",
    showHeaderOverflow: "title",
    showOverflow: true,
    fixed: "left",
  },
  {
    title: _that.$l("table_label_designer_name") || "设计师",
    field: "designerName",
    minWidth: 180,
    align: "left",
    headerAlign: "center",
    showHeaderOverflow: "title",
    showOverflow: true,
    fixed: "left",
  },
  {
    title: _that.$l("table_label_Product_line") || "产品线",
    field: "productLine",
    minWidth: 180,
    align: "left",
    headerAlign: "center",
    showHeaderOverflow: "title",
    showOverflow: true,
    fixed: "left",
  },
  {
    title: _that.$l("table_label_Sample_classification") || "样品分类",
    field: "categoryName",
    minWidth: 180,
    align: "left",
    headerAlign: "center",
    showHeaderOverflow: "title",
    showOverflow: true,
    fixed: "left",
  },
  {
    title: _that.$l("table_label_sampleCount") || "样品数量",
    field: "sampleCount",
    minWidth: 180,
    align: "left",
    headerAlign: "center",
    showHeaderOverflow: "title",
    showOverflow: true,
    fixed: "left",
  },
]
